<template>
   <vs-card class="separated vs-card-no-width">
        <template #title>
            <h3 >{{ value | currency }}</h3>
        </template>

        <template #text>
            <small>
            {{ title  }}
            </small>
            <hr class="line-color" :style="'background-color:' + color" >
        </template>
    </vs-card>
</template>
<script>
export default {
    props:[
        "title",
        "value",
        "color"
    ],
    data () {
        return {
            data: {}
        }
    },
    methods:{
        
    },
    watch: {
       
    }
    
}
</script>

<style lang="scss"  scoped >
.line-color {
    margin-bottom:0.2em;
    width:100%;
    text-align:left;
    margin-left:0;
    height:5px
}

</style>